import { useTheme } from "@emotion/react";
import CloseIcon from "@mui/icons-material/Close";
import { FormControl, IconButton, MenuItem, Select } from "@mui/material";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import { LineChart } from "@mui/x-charts";
import { default as React, useCallback, useEffect, useState } from "react";
import axiosInstance from "../../../utils/axiosInstance";

export default function UserActivityModal({ open, onClose, userId }) {
  const [days, setDays] = useState(7); // User activity day range
  const [userActivity, setUserActivity] = useState({});

  const theme = useTheme();

  const fetchUserActivity = useCallback(async () => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}/user-activity/user/${userId}/${days}`,
      );

      if (response.status === 200) {
        setUserActivity(response.data);
        setUserActivity({
          dates: Object.keys(response.data),
          count: Object.values(response.data).map(Number),
        });
      }
    } catch (error) {}
  }, [days, userId]);

  useEffect(() => {
    fetchUserActivity();
  }, [fetchUserActivity]);

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "90%",
          maxWidth: 700,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
          maxHeight: "80vh",
          overflow: "auto",
          [theme.breakpoints.down("md")]: {
            maxWidth: "70%",
          },
        }}
      >
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>

        <Box>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            User Activity
          </Typography>
          <FormControl margin="normal">
            <Select
              id="days"
              name="days"
              value={days}
              onChange={(e) => {
                setDays(parseInt(e.target.value));
                // fetchUserActivity();
              }}
            >
              <MenuItem value={7}>7 Days</MenuItem>
              <MenuItem value={15}>15 Days</MenuItem>
              <MenuItem value={30}>30 Days</MenuItem>
              <MenuItem value={90}>90 Days</MenuItem>
            </Select>
          </FormControl>
        </Box>

        {userActivity && userActivity.dates && userActivity.count && (
          <LineChart
            height={300}
            series={[
              {
                data: userActivity.count,
                area: false,
                showMark: false,
              },
            ]}
            xAxis={[{ scaleType: "point", data: userActivity.dates }]}
          />
        )}
      </Box>
    </Modal>
  );
}
